export default __webpack_public_path__ + "static/media/officelite.34773de6.svg";